import Vue from 'vue'
import store from '@/vuex/store'
import * as types from '@/vuex/types'
// import {PAGE_PERMISSION_MAP} from './permission'
import Router from 'vue-router'
import Login from '@/components/frame/Login'
import Error from '@/components/frame/Error'
import Home from '@/components/frame/Home'
import Success from '@/components/frame/Success'
import Company from '@/components/frame/company/CompanyHome'
import Info from '@/components/frame/showCompany/showCompany'
Vue.use(Router)

export let routes = []
const routerContext = require.context('./modules', true, /\.js$/)
routerContext.keys().forEach(route => {
  const routerModule = routerContext(route)
  const router = routerModule.default || routerModule
  if (router.isShow) {
    routes.push(router)
  }
  // routes = [...routes, ...(routerModule.default || routerModule)]
})
const router = new Router({
  // scrollBehavior (to,from,savedPosition){
  //   // return 期望滚动到哪个位置
  //   // 返回原来的位置
  //   // return savePosition
  //   // 返回页面顶部
  //   return { x:0, y:0 }
  // },
  mode: 'history',
  routes: [
    ...routes,
    // 默认进入路劲
    {
      path: '/', redirect: '/login'
    },
    // 登录页面
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // 企业管理（工作台）
    // {
    //   path: '/home',
    //   component: Home,
    //   name: 'home',
    //   redirect: '/home/index',
    //   children: [
    //     {
    //       path: 'index',
    //       name: 'home/index',
    //       component: () => import('@/views/dataViews/dataViews'),
    //       meta: {title: '整体数据概况', close: false}
    //     }
    //   ]
    // },
    // 系统资料
    {
      path: '/systemData',
      name: 'systemData',
      component: Home,
      children: [
        {path: '/', name: 'page', redirect: 'index'},
        {
          path: 'index',
          name: 'systemData/index',
          component: () => import('@/views/systemData/systemData'),
          meta: {title: '系统资料', close: true}
        }
      ]
    },
    // 区域管理
    {
      path: '/areaManagement',
      component: Home,
      name: 'areaManagement',
      redirect: '/areaManagement/index',
      children: [
        {
          path: 'index',
          name: 'areaManagement/index',
          component: () => import('@/views/systemSetting/areaManagement'),
          meta: {title: '区域管理', close: true}
        },
        {
          path: 'AccountManagement',
          name: 'AccountManagement',
          component: () => import('@/views/systemSetting/manageAccount/index'),
          meta: { title: '账号管理', close: true }
        }
      ]
    },
    // 部门账号配置
    {
      path: '/departmentManagement',
      component: Home,
      name: 'departmentManagement',
      redirect: '/departmentManagement/index',
      children: [
        {
          path: 'index',
          name: 'departmentManagement/index',
          component: () => import('@/views/department/management/managementPage'),
          meta: {title: '部门账号配置', close: true}
        }
      ]
    },
    {
      path: '/townManagement',
      component: Home,
      name: 'townManagement',
      redirect: '/townManagement/index',
      children: [
        {
          path: 'index',
          name: 'townManagement/index',
          component: () => import('@/views/town/management/managementPage'),
          meta: {title: '街镇账号配置', close: true}
        }
      ]
    },
    {
      path: '/town',
      component: Home,
      name: 'index',
      redirect: '/town/index',
      children: [
        {
          path: 'index',
          name: 'town/index',
          component: () => import('@/views/town/townPage'),
          meta: {title: '相关街镇信息', close: true}
        }
      ]
    },
    // 相关部门信息
    {
      path: '/department',
      component: Home,
      name: 'department',
      redirect: '/department/departmentBase',
      children: [
        {
          path: 'departmentBase',
          name: 'department/departmentBase',
          component: () => import('@/views/department/department/departmentPage'),
          meta: {title: '基本信息调研', close: true}
        },
        {
          path: 'specialDepartment',
          name: 'department/specialDepartment',
          component: () => import('@/views/department/specialDepartment/specialDepartmentPage'),
          meta: {title: '特定信息调研', close: true}
        }
      ]
    },
    // 单位信息
    {
      path: '/company',
      component: Company,
      name: 'company',
      redirect: '/company/index',
      // meta: {title: ''},
      children: [
        {
          path: 'index',
          name: 'company/index',
          component: () => import('@/views/index/index'),
          meta: {title: '安全基本信息', close: false, isCompany: true}
        }
      ]
    },
    {
      path: '/unit',
      component: Company,
      name: 'unit',
      redirect: '/unit/index',
      // meta: {title: ''},
      children: [
        {
          path: 'index',
          name: 'unit/index',
          component: () => import('@/views/unit/unit'),
          meta: {title: '单元风险', close: true, isCompany: true}
        }
      ]
    },
    {
      path: '/staff',
      component: Company,
      children: [
        {path: '/', name: '', redirect: 'index'},
        {
          path: 'index',
          name: 'staff/index',
          component: () => import('@/views/staff/staff'),
          meta: {title: '人员机构', close: true, isCompany: true}
        }
      ]
    },
    {
      path: '/building',
      component: Company,
      children: [
        {path: '/', name: '', redirect: 'index'},
        {
          path: 'index',
          name: 'building/index',
          component: () => import('@/views/buildingInfo/BuildingInfo'),
          meta: {title: '场所管理', close: true, isCompany: true}
        }
      ]
    },
    {
      path: '/device',
      component: Company,
      children: [
        {path: '/', name: '', redirect: 'index'},
        {
          path: 'index',
          name: 'device/index',
          component: () => import('@/views/deviceInfo/DeviceInfo'),
          meta: {title: '设备管理', close: true, isCompany: true}
        }
      ]
    },
    {
      path: '/work',
      component: Company,
      children: [
        {path: '/', name: '', redirect: 'index'},
        {
          path: 'index',
          name: 'work/index',
          component: () => import('@/views/workInfo/workInfo'),
          meta: {title: '作业管理', close: true, isCompany: true}
        }
      ]
    },
    {
      path: '/controlCompliance',
      component: Company,
      // name: 'unit',
      // redirect: '/unit/index',
      // meta: {title: '工作台'},
      children: [
        {path: '/', name: '', redirect: 'index'},
        {
          path: 'index',
          name: 'controlCompliance/index',
          component: () => import('@/views/controlCompliance/controlCompliance'),
          meta: {title: '隐患上报', close: true, isCompany: true}
        }
      ]
    },
    {
      path: '/dynamic',
      component: Company,
      name: 'dynamic',
      redirect: '/dynamic/riskList',
      // meta: {title: ''},
      children: [
        {
          path: 'riskList',
          name: 'dynamic/riskList',
          component: () => import('@/views/dynamic/riskList'),
          meta: {title: '现实风险清单', close: true, isCompany: true}
        },
        {
          path: 'majorHazardSourceList',
          name: 'dynamic/majorHazardSourceList',
          component: () => import('@/views/dynamic/majorHazardSourceList'),
          meta: {title: '重大危险源清单', close: true, isCompany: true}
        },
        {
          path: 'yinhuan',
          name: 'dynamic/yinhuan',
          component: () => import('@/views/dynamic/hiddenList/hiddenListPage'),
          meta: {title: '隐患治理清单', close: true, isCompany: true}
        },
        {
          path: 'riskLevelMap',
          name: 'dynamic/riskLevelMap',
          component: () => import('@/views/dynamic/riskLevelMap'),
          meta: {title: '风险四色图', close: true, isCompany: true}
        }
      ]
    },
    // 纯信息展示的页面（大屏跳至后台）
    {
      path: '/info',
      component: Info,
      name: 'info',
      redirect: '/info/base',
      children: [
        {
          path: 'hiddenList',
          name: 'info/hiddenList',
          component: () => import('@/views/infoPage/hiddenList'),
          meta: {title: '隐患列表', close: false}
        },
        {
          path: 'hiddenPage',
          name: 'info/hiddenPage',
          component: () => import('@/views/infoPage/hiddenPage'),
          meta: {title: '隐患治理', close: false}
        },
        {
          path: 'admin',
          name: 'info/admin',
          component: () => import('@/views/infoPage/admin'),
          meta: {title: '隐患', close: false}
        },
        {
          path: 'base',
          name: 'info/base',
          component: () => import('@/views/infoPage/base'),
          meta: {title: '基本信息', close: false}
        },
        {
          path: 'unit',
          name: 'info/unit',
          component: () => import('@/views/infoPage/unit'),
          meta: {title: '单元安全参数', close: false}
        },
        {
          path: 'unitMulti',
          name: 'info/unitMulti',
          component: () => import('@/views/infoPage/unitMulti'),
          meta: {title: '单元信息', close: false}
        },
        {
          path: 'hidden',
          name: 'info/hidden',
          component: () => import('@/views/infoPage/hidden'),
          meta: {title: '隐患信息', close: false}
        },
        {
          path: 'risk',
          name: 'info/risk',
          component: () => import('@/views/infoPage/risk'),
          meta: {title: '风险点信息', close: false}
        },
        {
          path: 'echart',
          name: 'info/echart',
          component: () => import('@/views/infoPage/echart'),
          meta: {title: '图表', close: false}
        },
        {
          path: 'riskCheck',
          name: 'info/riskCheck',
          component: () => import('@/views/infoPage/riskCheck'),
          meta: {title: '检查记录', close: false}
        },
        {
          path: 'riskList',
          name: 'info/riskList',
          component: () => import('@/views/infoPage/riskList'),
          meta: {title: '风险管控到位率', close: false}
        },
        {
          path: 'emergency',
          name: 'info/emergency',
          component: () => import('@/views/infoPage/emergency'),
          meta: {title: '应急管理', close: false}
        },
        {
          path: 'accident',
          name: 'info/accident',
          component: () => import('@/views/infoPage/accident'),
          meta: {title: '应急管理', close: false}
        },
        {
          path: 'hiddenInfo',
          name: 'info/hiddenInfo',
          component: () => import('@/views/infoPage/hiddenInfo'),
          meta: {title: '隐患治理', close: false}
        },
        {
          path: 'education',
          name: 'info/education',
          component: () => import('@/views/infoPage/education'),
          meta: {title: '安全教育培训', close: false}
        },
        {
          path: 'hidenCheck',
          name: 'info/hidenCheck',
          component: () => import('@/views/infoPage/hidenCheck'),
          meta: {title: '隐患清单', close: false}
        },
        {
          path: 'majiorHidden',
          name: 'info/majiorHidden',
          component: () => import('@/views/infoPage/majiorHidden'),
          meta: {title: '重大隐患管理', close: false}
        },
        {
          path: 'securityCheck',
          name: 'info/securityCheck',
          component: () => import('@/views/infoPage/securityCheck'),
          meta: {title: '整改清单', close: false}
        },
        {
          path: 'managementPage',
          name: 'info/managementPage',
          component: () => import('@/views/infoPage/managementPage'),
          meta: {title: '一企一档', close: false}
        },
        {
          path: 'riskInventory',
          name: 'info/riskInventory',
          component: () => import('@/views/infoPage/riskInventory'),
          meta: {title: '风险清单', close: false}
        },
        {
          path: 'supervisionInspection',
          name: 'info/supervisionInspection',
          component: () => import('@/views/infoPage/supervisionInspection'),
          meta: {title: '监督检查管理', close: false}
        },
        {
          path: 'supervisionCheck',
          name: 'info/supervisionCheck',
          redirect: '/info/supervisionCheck/check_manage',
          component: () => import('@/views/infoPage/supervisionCheck'),
          meta: {title: '监督检查', close: false},
          children: [
            {
              path: 'check_manage',
              name: 'check_manage',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/check_manage/index'),
              meta: {title: '监督检查管理', close: false}
            },
            {
              path: 'check_object',
              name: 'check_object',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/check_object/index'),
              meta: {title: '临时检查对象', close: false}
            },
            {
              path: 'check_quest',
              name: 'check_quest',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/check_quest/index'),
              meta: {title: '检查任务部署', close: false}
            },
            {
              path: 'check_task',
              name: 'check_task',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/check_task/index'),
              meta: {title: '待检查任务', close: false}
            },
            {
              path: 'handover_tracking',
              name: 'handover_tracking',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/handover_tracking/index'),
              meta: {title: '隐患移交跟踪', close: false}
            },
            {
              path: 'trace_table',
              name: 'trace_table',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/trace_table/index'),
              meta: {title: '任务隐患跟踪表', close: false}
            },
            {
              path: 'statistics',
              name: 'statistics',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/statistics/index'),
              meta: {title: '层级隐患数统计', close: false}
            },
            {
              path: 'dynamic_manage',
              name: 'dynamic_manage',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/dynamic_manage/index'),
              meta: {title: '隐患动态管理', close: false}
            },
            {
              path: 'check_deployment',
              name: 'check_deployment',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/check_plan/table'),
              meta: {title: '企业专项检查部署', close: false}
            },
            {
              path: 'planned_deployment',
              name: 'planned_deployment',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/check_plan/table2'),
              meta: {title: '政府检查计划部署', close: false}
            },
            {
              path: 'expert_database',
              name: 'expert_database',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/check_plan/SupervisionExportTable'),
              meta: {title: '检查专家库管理', close: false}
            },
            {
              path: 'industry_field',
              name: 'industry_field',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/Check_list/index'),
              meta: {title: '行业领域检查清单', close: false}
            },
            {
              path: 'grid_staff',
              name: 'grid_staff',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/Check_list/meshWelding'),
              meta: {title: '网格员检查导则', close: false}
            },
            {
              path: 'special_project',
              name: 'special_project',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/Check_list/specialList'),
              meta: {title: '专项检查清单', close: false}
            },
            {
              path: 'hidden_danger',
              name: 'hidden_danger',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/Check_list/dangerList'),
              meta: {title: '重大隐患检查清单', close: false}
            },
            {
              path: 'subject_responsibility',
              name: 'subject_responsibility',
              component: () => import('@/views/infoPage/components/table/supervisionCheck/Check_list/mainCheckList'),
              meta: {title: '主体责任检查清单', close: false}
            },
          ]
        },
        
      ]
    },
    {
      path: '/success', name: 'success', component: Success
    },
    {
      path: '/newcxgj',
      name: 'standardize/newcxgj',
      component: () => import('@/views/standardize/newcxgj'),
      meta: {title: '持续改进', close: true, isCompany: true}
    },
    {
      path: '*', name: 'error', component: Error
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js